var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.448 13.448c1.296-1.534 2.458-2.927 3.77-4.488.08-.098.24-.036.24.088 0 2.28-.044 4.551.009 6.831.018.878-.79 1.783-1.783 1.774-5.039-.044-10.078-.018-15.125-.018H.488a.492.492 0 0 0-.488.488v3.433c0 .231.186.417.417.417h.027c5.393 0 10.787.01 16.18 0 1.446 0 2.83-.248 3.939-1.295.976-.913 1.5-2.013 1.49-3.37-.018-2.706-.009-5.412-.009-8.118v-.15c.01-.16.213-.222.32-.098 1.224 1.464 2.44 2.927 3.69 4.418.169.204.47.23.674.062.78-.648 1.562-1.287 2.351-1.934a.516.516 0 0 0 .062-.745C26.161 7.248 23.18 3.77 20.173.24a.573.573 0 0 0-.87 0L10.46 10.734a.478.478 0 0 0 .062.674c.887.736 1.579 1.322 2.466 2.058.169.124.346.124.461-.018z",
    fill: "#36D66B",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpturn);
export default __webpack_public_path__ + "static/media/arrow-upturn.d24dbf89cd0a0490b8a8c7d668704777.svg";
export { ForwardRef as ReactComponent };